// drawer/components/MitreAttacksComponent.tsx
import { OverflowText } from '@/components/OverflowText';
import { Table } from '@/components/table/Table';
import { Section } from '@/sections/threats/components';
import type {
  EnrichedVulnerability,
  MitreTechnique,
} from '@/sections/threats/types';

interface MitreAttacksComponentProps {
  threatIntel?: EnrichedVulnerability;
}

/**
 * MITRE ATT&CK techniques table component
 */
export function MitreAttacksComponent({
  threatIntel,
}: MitreAttacksComponentProps) {
  const { mitre_techniques = [] } = threatIntel ?? {};

  return (
    <Section title="MITRE ATT&CK">
      {mitre_techniques.length === 0 && (
        <p className="text-sm">No known information at this time</p>
      )}
      {mitre_techniques.length > 0 && (
        <Table<MitreTechnique>
          name="mitreAttacks"
          status="success"
          columns={[
            { label: 'Technique ID', id: 'id', fixedWidth: 150 },
            {
              label: 'URL',
              id: 'url',
              cell: item => (
                <OverflowText
                  className="text-chariot-brand-primary"
                  text={item.url || '-'}
                />
              ),
              onClick: item => {
                window.open(item.url, '_blank');
              },
            },
            { label: 'Name', id: 'name' },
          ]}
          data={mitre_techniques}
          error={null}
          selection={{ hide: true }}
        />
      )}
    </Section>
  );
}
